"use client";

import styles from "./StudentTestimonial.module.scss";
import cn from "clsx";
import SectionCardWithBg from "@/revamp/molecules/SectionCardWithBg";
import ArrowRight from "@/SvgIcons/ArrowRight";
import VideoWrapper from "@/revamp/organisms/VideoWrapper";
import { pushToDataLayer } from "@/helpers/gtag";
import TestimonialsCarousel from  "@/components/sections/TestimonialStudent";
import Markdown from "@/components/atoms/Markdown";
import CommonButton from "@/components/common/Analytics/CustomButton";


const brandData = {
  Title: { text: "Open & Honest Reviews by our Learners", enabled: true },
  SubTitle: { text: "", enabled: true },
};

const brandDataTwo = {
  Title: { text: "Hear what our students have to say kjkjk", enabled: true },
  SubTitle: { text: "Discover student learning experiences and journeys at Amity Online", enabled: true },
}
const brandDataThree = {
  Title: { text: "Hear From Our Students", enabled: true },
  SubTitle: { text: "Get a glimpse into the learning experiences and journeys of students at Amity Online", enabled: true },
  p:{text:"Video Testimonials",enabled:true}
}
const brandDataFour = {
  Title: { text: "Our Faculty's Testimonials", enabled: true },
  Subtitle:{}
}


export default function StudentTestimonial({ isMobile,testimonials=[],isStudentStory,isRicsPage }: { isMobile: boolean, testimonials: any,isStudentStory?: boolean,isRicsPage?: boolean }) {
  
  const newBrandData =isRicsPage?brandDataFour: isStudentStory?brandDataThree:!!testimonials?.length ? brandData : brandDataTwo;
 
   
  const handleGaClick = () => {
    pushToDataLayer({
      cta_text : "FAST TRACK YOUR CAREER",
      page_type : "Home Page",
      page_url : window.location.href || "NA"
    })
  } 
  

  return (
    <section
      className={cn(
        styles.testimonialSection,
        {
          [styles.noBackground]: isStudentStory,
          ["mt-10 "]: isStudentStory,
        },

        "relative sm:mt-4"
      )}
    >
      {!isStudentStory && (
        <div className={cn(styles.gradient, styles.darkBottomGradient)}></div>
      )}

      {!isStudentStory && (
        <SectionCardWithBg
          isStudentStory={isStudentStory}
          isSplitSubtitle={false}
          {...newBrandData}
          hideHr={true}
        />
      )}
      {isStudentStory && (
        <div className={styles.heading}>
          <div className={styles.title}>
          Hear From Our <span>Students
          <img
            src="https://amityonline.com/_s/Asset_12_4_0e2fa08ab5.webp"
            className={styles.vector}
          />
          </span>
          </div>
          <Markdown className={styles.subTitle}>
            {brandDataThree?.SubTitle?.text}
          </Markdown>
          <p className={styles.para}>
          {brandDataThree?.p?.text}
          </p>
          <img
            className={styles.iconImg}
            src="https://amityonline.com/_s/7fea6d3cd14ef39635f4ebb64ffc152d615ff079_5de83237f8.webp"
          />
        </div>
      )}
      {!isStudentStory &&!isRicsPage&& <TestimonialsCarousel testimonials={testimonials} />}
      <div className={styles.testimonialContainer}>
        {isStudentStory && (
          <div className={styles.studentBtn}>
                <CommonButton
                    href={"/student-story/video"}
                    type={"link"}
                    icon="/_a/icons/left-arrow.svg"
                    hoverIcon="/_a/icons/left-arrow-white.svg"
                    bg="o"
                    color="b"
                >
                    View All
                </CommonButton>
            </div>
        )}
        <VideoWrapper isStudentStory={isStudentStory} isMobile={isMobile} />
        {!isStudentStory && !isRicsPage&& (
          <div className={styles.cta}>
            <a
              href="/student-story"
              onClick={handleGaClick}
              className={styles.ctaButton}
            >
              See Alumni Success Stories
              <span className={styles.arrowIcon}>
                <ArrowRight color="#fff" />
              </span>
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
